import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { Data } from '../../signup-data/DATA';
import { ManagementLevel } from '../../signup-data/ManagementLevelOption';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { bulkSetSignupDataAndSetValid } from '../../store/signup-data/action-creators';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { Step } from '../../views/Step';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
export const BranchACQ134CompanySize = {
  name: 'BranchACQ134CompanySize',
  stateCheck: state => {
    return getSignupDataValue(state, Data.CompanySize) === CompanySizeOption.One && getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0134, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    dispatch(bulkSetSignupDataAndSetValid({
      [Data.ManagementLevel]: ManagementLevel.Owner
    }));
    const nextSteps = NextStepManager.removeSteps(Step.ManagementLevel)(flow);
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.CompanySize,
  afterData: null,
  afterStep: null
};